module.exports = "\n<app-navbar></app-navbar>\n<router-outlet></router-outlet>\n<app-footer></app-footer>\n\n"


//////////////////
// WEBPACK FOOTER
// /Users/diego/Documents/SirisWebSite/WebSite/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main